import logo from './logo.jpg';
import './App.css';
import React, { useState, useEffect } from 'react';
import Inicio from './componentes/Inicio';
import AgregarEntrada from './componentes/AgregarEntrada';
import AgregarSalida from './componentes/AgregarSalida';
import GetSalida from './componentes/GetSalida';
import GetEntrada from './componentes/GetEntrada';
import {BrowserRouter,Routes, Route} from 'react-router-dom';
import CrearProducto from './componentes/CrearProducto'
import GetProductos from './componentes/GetProductos'
import FiltrarEgresos from './componentes/FiltrarEgresos';
import FinalizarCompra from './componentes/FinalizarCompra.jsx'
import Pedidos from './componentes/Pedidos.jsx';
import GenerarFactura from './componentes/GenerarPDF.jsx';
import CrearUsuarios from './componentes/CrearUsuarios.jsx';
import GetTarjetas from './componentes/GetTarjetas.jsx';
import BuscarTarjeta from './componentes/BuscarTarjeta.jsx';
import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQuery, gql } from '@apollo/client';
import EstadisticaMensual from './componentes/EstadisticaMensual.jsx';
import FacturaCliente from './componentes/FacturaCliente.jsx';

const GET_USUARIOS = gql`
query getUsuarios{
    getUsuarios{
        _id
        nombre
        rol
        contacto
        correo
        direccion

    }
}`

function App() {
  
 /* const {user, isAuthenticated, loginWithRedirect,logout } = useAuth0();*/
  const {loading, error, data} = useQuery(GET_USUARIOS);
  const [isAdmin, setIsAdmin] = useState(false);
  
  /*useEffect(() => {
    if (!loading && isAuthenticated && data && user) {
      const isAdminUser = data.getUsuarios.find(usuario => usuario.correo === user.email && usuario.rol === "administrador" );
      setIsAdmin(isAdminUser !== undefined);
    }
  }, [loading, data, isAuthenticated, user]);
  if (!isAuthenticated) {
    return <div class="alert alert-success" role="alert">
    No tienes permisos  para acceder a esta página. 


    &nbsp;
    
    
  <button className='btn btn-success' onClick={() => loginWithRedirect()}>
      Ingresar
    </button>
  
  </div>
  }
  */
  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error</p>;

  return (
    <div className="">
       <BrowserRouter>
      
     
       
     <Routes>
      <Route path="/" axact element={<GetProductos></GetProductos>}></Route>
         <Route path="/inicio" exact element={<Inicio/>}></Route>
        <Route path="/ingresos" exact element={<AgregarEntrada></AgregarEntrada>}></Route>
        <Route path="/egresos" exact element={<AgregarSalida></AgregarSalida>}></Route>
        <Route path="/ver-egresos" exact element={<GetSalida></GetSalida>}></Route>
        <Route path="/ver-ingresos" exact element={<GetEntrada></GetEntrada>}></Route>
        <Route path="/crear-product" exact element={<CrearProducto></CrearProducto>}></Route>
      <Route path="/finalizar-compra" exact element={<FinalizarCompra></FinalizarCompra>}></Route>
      <Route path='/pedidos' exact element={<Pedidos></Pedidos>}></Route>
      <Route path='/pdf' exact element={<GenerarFactura></GenerarFactura>}></Route>
      <Route path='/crear-usuario' exact element={<CrearUsuarios></CrearUsuarios>}></Route>
      <Route path='/estadisticas' exact element={<EstadisticaMensual></EstadisticaMensual>}></Route>
      <Route path='/tarjetas'exact element={<GetTarjetas></GetTarjetas>}></Route>
      <Route path='/search'exact element={<BuscarTarjeta></BuscarTarjeta>}></Route>*/
        <Route path="factura/:numeroPedido" exact element={<FacturaCliente></FacturaCliente>}></Route>
      
       </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
